/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AccountVerificationService } from './services/AccountVerificationService';
import { AgentsService } from './services/AgentsService';
import { AppService } from './services/AppService';
import { AuthService } from './services/AuthService';
import { AutocompleteService } from './services/AutocompleteService';
import { BrandsService } from './services/BrandsService';
import { ContentReportsService } from './services/ContentReportsService';
import { DashboardService } from './services/DashboardService';
import { DashboardFeatureFlagsService } from './services/DashboardFeatureFlagsService';
import { DashboardSecurityService } from './services/DashboardSecurityService';
import { FeatureFlagsService } from './services/FeatureFlagsService';
import { DocumentsService } from './services/DocumentsService';
import { FeedService } from './services/FeedService';
import { GeoRegionsService } from './services/GeoRegionsService';
import { GlobalSettingsService } from './services/GlobalSettingsService';
import { InterventionsService } from './services/InterventionsService';
import { InvoicesService } from './services/InvoicesService';
import { LocationsService } from './services/LocationsService';
import { MapService } from './services/MapService';
import { MunicipalitiesService } from './services/MunicipalitiesService';
import { MunicipalityDashboardService } from './services/MunicipalityDashboardService';
import { NeighborhoodService } from './services/NeighborhoodService';
import { NeighboringReportsService } from './services/NeighboringReportsService';
import { NotificationsService } from './services/NotificationsService';
import { PostsService } from './services/PostsService';
import { ReportsService } from './services/ReportsService';
import { ReportTemplatesService } from './services/ReportTemplatesService';
import { SectorsService } from './services/SectorsService';
import { SecurityService } from './services/SecurityService';
import { SecurityDomainsService } from './services/SecurityDomainsService';
import { SiretVerificationService } from './services/SiretVerificationService';
import { SocietiesService } from './services/SocietiesService';
import { SponsorshipService } from './services/SponsorshipService';
import { StripeService } from './services/StripeService';
import { TransactionsService } from './services/TransactionsService';
import { UploadsService } from './services/UploadsService';
import { UsersService } from './services/UsersService';
import { VerificationService } from './services/VerificationService';
import { WalletService } from './services/WalletService';
import { WellKnownService } from './services/WellKnownService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class WisecureApiClient {
    public readonly accountVerification: AccountVerificationService;
    public readonly agents: AgentsService;
    public readonly app: AppService;
    public readonly auth: AuthService;
    public readonly autocomplete: AutocompleteService;
    public readonly brands: BrandsService;
    public readonly contentReports: ContentReportsService;
    public readonly dashboard: DashboardService;
    public readonly dashboardFeatureFlags: DashboardFeatureFlagsService;
    public readonly dashboardSecurity: DashboardSecurityService;
    public readonly featureFlags: FeatureFlagsService;
    public readonly documents: DocumentsService;
    public readonly feed: FeedService;
    public readonly geoRegions: GeoRegionsService;
    public readonly globalSettings: GlobalSettingsService;
    public readonly interventions: InterventionsService;
    public readonly invoices: InvoicesService;
    public readonly locations: LocationsService;
    public readonly map: MapService;
    public readonly municipalities: MunicipalitiesService;
    public readonly municipalityDashboard: MunicipalityDashboardService;
    public readonly neighborhood: NeighborhoodService;
    public readonly neighboringReports: NeighboringReportsService;
    public readonly notifications: NotificationsService;
    public readonly posts: PostsService;
    public readonly reports: ReportsService;
    public readonly reportTemplates: ReportTemplatesService;
    public readonly sectors: SectorsService;
    public readonly security: SecurityService;
    public readonly securityDomains: SecurityDomainsService;
    public readonly siretVerification: SiretVerificationService;
    public readonly societies: SocietiesService;
    public readonly sponsorship: SponsorshipService;
    public readonly stripe: StripeService;
    public readonly transactions: TransactionsService;
    public readonly uploads: UploadsService;
    public readonly users: UsersService;
    public readonly verification: VerificationService;
    public readonly wallet: WalletService;
    public readonly wellKnown: WellKnownService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.accountVerification = new AccountVerificationService(this.request);
        this.agents = new AgentsService(this.request);
        this.app = new AppService(this.request);
        this.auth = new AuthService(this.request);
        this.autocomplete = new AutocompleteService(this.request);
        this.brands = new BrandsService(this.request);
        this.contentReports = new ContentReportsService(this.request);
        this.dashboard = new DashboardService(this.request);
        this.dashboardFeatureFlags = new DashboardFeatureFlagsService(this.request);
        this.dashboardSecurity = new DashboardSecurityService(this.request);
        this.featureFlags = new FeatureFlagsService(this.request);
        this.documents = new DocumentsService(this.request);
        this.feed = new FeedService(this.request);
        this.geoRegions = new GeoRegionsService(this.request);
        this.globalSettings = new GlobalSettingsService(this.request);
        this.interventions = new InterventionsService(this.request);
        this.invoices = new InvoicesService(this.request);
        this.locations = new LocationsService(this.request);
        this.map = new MapService(this.request);
        this.municipalities = new MunicipalitiesService(this.request);
        this.municipalityDashboard = new MunicipalityDashboardService(this.request);
        this.neighborhood = new NeighborhoodService(this.request);
        this.neighboringReports = new NeighboringReportsService(this.request);
        this.notifications = new NotificationsService(this.request);
        this.posts = new PostsService(this.request);
        this.reports = new ReportsService(this.request);
        this.reportTemplates = new ReportTemplatesService(this.request);
        this.sectors = new SectorsService(this.request);
        this.security = new SecurityService(this.request);
        this.securityDomains = new SecurityDomainsService(this.request);
        this.siretVerification = new SiretVerificationService(this.request);
        this.societies = new SocietiesService(this.request);
        this.sponsorship = new SponsorshipService(this.request);
        this.stripe = new StripeService(this.request);
        this.transactions = new TransactionsService(this.request);
        this.uploads = new UploadsService(this.request);
        this.users = new UsersService(this.request);
        this.verification = new VerificationService(this.request);
        this.wallet = new WalletService(this.request);
        this.wellKnown = new WellKnownService(this.request);
    }
}

